import BaseService from '@/services/base_service';

export default class CityService extends BaseService {
    searchCep(cep) {
        return new Promise((resolve, reject) => {
            axios.get('/endereco/busca-cep/' + cep).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/address.js